import { TileLayer } from '@deck.gl/geo-layers';
import { parse } from '@loaders.gl/core';

import { geoBbox } from './tileBbox';
import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

export const dmrLayer = () =>
  new TileLayer({
    id: 'dmr-layer',
    getTileData: async ({ index: { x, y, z }, bbox }) => {
      const { east, south, north, west } = geoBbox(bbox);
      const url = `https://ags.cuzk.cz/arcgis2/services/dmr5g/ImageServer/WMSServer?&service=WMS&request=GetMap&layers=dmr5g%3AGrayscaleHillshade&styles=&format=image%2Fjpeg&transparent=false&version=1.1.1&width=256&height=256&srs=EPSG%3A4326&bbox=${west},${south},${east},${north}`;
      const result = await fetch(url);
      const data = await parse(result);
      return data;
    },
    maxRequests: 17,
    pickable: true,
    highlightColor: [60, 60, 60, 40],
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 0.7,
    renderSubLayers: renderBitmapTileSubLayer,
  });
